export default __webpack_public_path__ + "static/media/image-6.deddd3a1.png";